import { Base2Presenter } from "core/presenter";
import { OmsRepository } from "core/repository";

class Oms extends Base2Presenter {
  initialState() {
    return {
      loading: true,
      errors: "",
      data: [],
      organizations: [],
      stocks: [],
      sale_channels: [],
      companyUuid: ""
    };
  }
  onStart() {
    this.load();
  }

  async load() {
    const companyUuid = this.routeParams.companyUuid;

    this.enqueue({ loading: !!companyUuid });

    if (!companyUuid) return;

    const result = await OmsRepository.getOms(companyUuid);

    if (result.success) {
      this.enqueue({ data: result.data, companyUuid });
    } else {
      this.sendAlert({
        type: "error",
        title: "Oops...",
        content:
          "Não conseguimos buscar as integrações para esta empresa! Tente novamente em alguns minutos."
      });
    }

    this.enqueue({ loading: false });
  }

  async createForm(form) {
    const currentUser = await this.mRuntime.get("currentUser");
    const companyUuid = this.routeParams.companyUuid;

    form = {
      ...form,
      company_uuid: companyUuid,
      account_uuid: currentUser.account_uuid
    };

    return await OmsRepository.createOms(form);
  }

  async updateForm(uuid, form) {
    const currentUser = await this.mRuntime.get("currentUser");
    const companyUuid = this.routeParams.companyUuid;

    form = {
      ...form,
      company_uuid: companyUuid,
      account_uuid: currentUser.account_uuid
    };

    return await OmsRepository.updateOms(uuid, form);
  }

  async validForm(form) {
    // Todo: check a validação.
    let error = [];
    let valid = true;
    const schema = ["token", "sale_channel_id", "stock_id", "organization_id"];

    schema.forEach(item => {
      if (form[item] === "") {
        valid = false;
        return (error[item] = "Campo Obrigatório.");
      }
      return (error[item] = "");
    });

    return { error: error, valid: valid };
  }

  async onSave(form, editing, modal, uuid) {
    const resultValidation = await this.validForm(form);
    let result = false;

    if (editing && resultValidation.valid) {
      result = await this.updateForm(uuid, form);
    } else if (resultValidation.valid) {
      result = await this.createForm(form);
    } else {
      this.enqueue({ errors: resultValidation.error });
    }

    if (result.success && resultValidation.valid) {
      this.sendAlert({
        type: "success",
        content: "Integração habilitada com sucesso!"
      });
      this.load();
      modal();
    }

    this.load();
  }

  sendAlert({ type, title, content }) {
    this.sendNotification({
      type: type,
      title: title,
      content: content
    });
  }

  async onSaveEnabled(value) {
    value.enabled = !value.enabled;

    const result = await OmsRepository.updateOms(value.uuid, value);

    if (result) {
      this.sendAlert({
        type: "success",
        content: `Integração ${
          result.data.enabled ? "habilitada" : "desabilitada"
        }  com sucesso!`
      });
      this.load();
    } else {
      this.sendAlert({
        type: "error",
        title: "Oops...",
        content:
          "Não conseguimos habilitar/desabilitar essa integração! Tente novamente em alguns minutos."
      });
    }
  }

  async fetchOrganizations(token) {
    if (!token) return;

    const result = await OmsRepository.fetchOrganizations(token);

    switch (result.status) {
      case 200:
        this.enqueue({ organizations: result.data.organizations });
        break;

      case 422:
        this.enqueue({ errors: "token" });
        break;

      default:
        this.sendAlert({
          type: "error",
          title: "Oops...",
          content:
            "Não conseguimos buscar as integrações para esta empresa! Tente novamente em alguns minutos."
        });
    }
  }

  async fetchStocks(token, organizationId) {
    if (!token || !organizationId) return;

    const result = await OmsRepository.fetchStocks(token, organizationId);

    switch (result.status) {
      case 200:
        this.enqueue({ stocks: result.data.stocks });
        break;

      case 422:
        this.enqueue({ errors: "organization_id" });
        break;

      default:
        this.sendAlert({
          type: "error",
          title: "Oops...",
          content:
            "Não conseguimos buscar as integrações para esta empresa! Tente novamente em alguns minutos."
        });
    }
  }

  async fetchSaleChannels(token, organizationId, stockId) {
    if (!token || !organizationId || !stockId) return;

    const result = await OmsRepository.fetchStocks(token, organizationId);

    switch (result.status) {
      case 200:
        const selectedStock = result.data.stocks.find(
          stock => stock.id === parseInt(stockId, 10)
        );

        if (selectedStock.sale_channels.length === 0) {
          this.sendAlert({
            type: "error",
            title: "Oops...",
            content:
              "Não há canais de venda disponíveis no estoque selecionado! Por favor selecione outro estoque."
          });
        }

        this.enqueue({ sale_channels: selectedStock.sale_channels });

        break;

      case 422:
        this.enqueue({ errors: "stocks_id" });
        break;

      default:
        this.sendAlert({
          type: "error",
          title: "Oops...",
          content:
            "Não conseguimos buscar as integrações para esta empresa! Tente novamente em alguns minutos."
        });
    }
  }
}

export default Oms;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/oms/presenter.js